import React, { Component } from 'react';
import { Input, Button, Icon } from 'semantic-ui-react';
import axios from 'axios';

import './code_entry.css';

export default class CodeEntry extends Component {
  constructor() {
    super();

    this.state = {
      code: null,
      submitDisabled: true,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    if (this.state.code) {
      this.setState({ submitDisabled: true }, () => {
        const data = {
          promotion_id: 'borrow_fmf',
          action: 'validation',
          code_value: this.state.code,
        };

        axios.post('https://api-service.evgo.com/promotion', data)
          .then((res) => {
            if (res.data.success) this.props.updateStep('registration', res.data.ref_value, res.data.code_type, this.state.code);
            else this.props.updateStep(`code_entry_${res.data.error_code}`, res.data.error_message);
          })
          .catch((err) => {
            console.log(err);
            this.props.updateStep('server_error', err.message);
          });
      });
    }
  }

  render() {
    return [
      <div key="code_entry_body" className="code_entry_body">
        <div className="code_entry_body_content img-overlay">
          <div className="code_entry_body_content_header">
            Please enter your one-time use promotion code corresponding to lease length.
          </div>

          <div className="code_entry_body_content_form">
            <Input
              className="code_entry_form_input"
              placeholder="Enter Code Here"
              onChange={ (e, d) => {
                this.setState({ code: d.value }, () => {
                  if (this.state.code) this.setState({ submitDisabled: false });
                });
              } }
              onKeyDown={ (e) => {
                if (e.which === 13) this.handleSubmit();
              } }
            />
            <Button
              className="code_entry_form_button blue"
              onClick={ this.handleSubmit }
              disabled={ this.state.submitDisabled }
              style={{ backgroundColor: '#00AEEF', color: '#FFFFFF' }}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>,

      <div key="code_entry_footer" className="code_entry_footer">
        <div className="code_entry_footer_content_left">
          <div>
            <Icon className="blue" name="question circle" />
            <b>Questions?</b>
          </div>

          <div>Call <b>877-494-3833</b> or email <b><a href="mailto:support@evgo.com" target="_blank" rel="noopener noreferrer">support@evgo.com</a></b></div>
        </div>

        <div className="code_entry_footer_content_right">
          <b>&copy; 2019 EVgo Services LLC</b>
        </div>

      </div>,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/content/code_entry/code_entry.js